document.addEventListener('DOMContentLoaded', () => {
  initCartDrawerEvents();

  // Header cart icon toggle
  const openBtn = document.getElementById('cart-drawer-toggle');
  if (openBtn) {
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const drawer = document.getElementById('cart-drawer');
      if (drawer) drawer.classList.toggle('cart-drawer--open');
    });
  }
});

function initCartDrawerEvents() {
  const drawer = document.getElementById('cart-drawer');
  const closeBtn = document.getElementById('cart-drawer-close');
  const overlay = document.getElementById('cart-drawer-overlay');

  const closeDrawer = () => drawer && drawer.classList.remove('cart-drawer--open');

  if (closeBtn) closeBtn.onclick = closeDrawer;
  if (overlay) overlay.onclick = closeDrawer;
}

// Intercept Add to Cart form submissions
document.addEventListener('submit', async (e) => {
  if (e.target.matches('form[action*="/cart/add"]')) {
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : 'Add to Bag';
    
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
    }

    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.status && data.status >= 400) {
        alert(data.description || 'Error adding item to cart');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }
        return;
      }

      // Update cart drawer section
      if (data.sections && data.sections['cart-drawer']) {
        const cartDrawerContainer = document.getElementById('cart-drawer');
        if (cartDrawerContainer) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.sections['cart-drawer'];
          const newContent = tempDiv.querySelector('.cart-drawer__content');
          const oldContent = cartDrawerContainer.querySelector('.cart-drawer__content');
          if (newContent && oldContent) {
            oldContent.innerHTML = newContent.innerHTML;
          }
        }
      }

      // Open drawer
      const drawer = document.getElementById('cart-drawer');
      if (drawer) {
        drawer.classList.add('cart-drawer--open');
      }

      // Re-enable button
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }

      initCartDrawerEvents();

    } catch (error) {
      console.error('Error adding to cart:', error);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    }
  }
});

// Handle Quantity Adjustments and Item Removal in Cart Drawer & Product Page
document.addEventListener('click', async (e) => {
  // Product Page Quantity Selector
  if (e.target.matches('.main-product .qty-btn')) {
    e.preventDefault();
    const btn = e.target;
    const input = btn.parentElement.querySelector('.qty-input');
    if (input) {
      let val = parseInt(input.value, 10) || 1;
      if (btn.getAttribute('data-action') === 'plus') {
        val += 1;
      } else if (btn.getAttribute('data-action') === 'minus' && val > 1) {
        val -= 1;
      }
      input.value = val;
    }
    return;
  }

  // Cart Drawer Quantity adjustments / Remove
  if (e.target.matches('.cart-drawer .qty-btn') || e.target.matches('.cart-drawer .cart-item__remove')) {
    e.preventDefault();
    const btn = e.target;
    const key = btn.getAttribute('data-key');
    let qty = btn.getAttribute('data-qty');
    
    if (e.target.matches('.cart-item__remove')) {
      qty = 0;
    }

    if (!key) return;

    try {
      const drawerContent = document.querySelector('.cart-drawer__content');
      if (drawerContent) drawerContent.style.opacity = '0.5';

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: parseInt(qty, 10),
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (data.sections && data.sections['cart-drawer']) {
        const cartDrawerContainer = document.getElementById('cart-drawer');
        if (cartDrawerContainer) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.sections['cart-drawer'];
          const newContent = tempDiv.querySelector('.cart-drawer__content');
          const oldContent = cartDrawerContainer.querySelector('.cart-drawer__content');
          if (newContent && oldContent) {
            oldContent.innerHTML = newContent.innerHTML;
          }
        }
      }

      if (drawerContent) drawerContent.style.opacity = '1';
      initCartDrawerEvents();

    } catch (error) {
      console.error('Error updating cart:', error);
      const drawerContent = document.querySelector('.cart-drawer__content');
      if (drawerContent) drawerContent.style.opacity = '1';
    }
  }
});
